<div class="md:tw-min-w-[770px] sm:tw-w-[500px] tw-w-[300px]">
  <!-- title -->
  <ng-container *ngIf="isShowDialogTitle">
    <app-modal-title
      [isShowClose]="true"
      (isCloseModal)="onClose()"
    ></app-modal-title>
  </ng-container>

  <div mat-dialog-content class="dialog-content">
    <app-custom-place-form
      [showAddToPublicPlace]="showAddToPublicPlace"
      [polygon]="polygon"
      [polygonTitles]="polygonTitles"
      [isShowManualPolygon]="false"
      (close)="onClose()"
      [customPlaceFormDialog]="true"
    >
    </app-custom-place-form>
  </div>
</div>
